import { useEffect, useState } from 'react';
import { Ban, CircleCheckBig, FileText } from 'lucide-react';
import Button from '@mui/material/Button';
import { Avatar, CircularProgress, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import { apiSpj } from '../../services/api';
import Modal from '../Modal/Modal';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

type ButtonUploadProps = {
    label: string
    route: string
    validFile?: string
    exeSuccess?: () => void
};

type filesUploadProps = {
    file: File,
    filename: string,
    progress: number,
    uploaded?: boolean,
    error?: boolean,
    url?: string
}

export default function ButtonUpload({ label, route, validFile, exeSuccess }: ButtonUploadProps) {
    const [filesUpload, setFilesUpload] = useState<filesUploadProps[]>([]);
    const [countProgress, setCountProgress] = useState(1);

    async function uploadFile(files: FileList | null) {
        let upFiles: filesUploadProps[] = [];
        if (files && files.length > 0) {
            for (let index = 0; index < files.length; index++) {
                const file = files.item(index);
                if (file) upFiles.push({ file: file, filename: file.name, progress: 0, error: validFile && !String(file.name).includes(validFile) ? true : false });
            }
            setFilesUpload(upFiles);
        }
    }

    async function processUpload(file: filesUploadProps, index: number) {
        if(!file.error){
            try {
                const data = new FormData();
                data.append('file', file.file);
                data.append('filename', file.filename);
                apiSpj.post(route, data, { 
                    headers: { filename: file.filename },
                    onUploadProgress: e => {
                        const progress = parseInt(String(Math.round((e.loaded * 100) / Number(e.total))));
                        let up = filesUpload;
                        up[index].progress = progress;
                        console.log(progress);
                        setFilesUpload(up);
                        setCountProgress(old => old + 1);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        if (filesUpload.length > 0) {
            filesUpload.forEach(processUpload);
        }
    }, [filesUpload])

    return (
        <>
            <Modal
                open={filesUpload.length > 0}
                setOpen={() => setFilesUpload([])}
                title='Upload de Documentos'
                zIndex={9999}
                maxWidth='sm'
                actionClose={exeSuccess}
            >
                <div>
                    <List dense>
                        {countProgress && filesUpload.map(file => (
                            <ListItem
                                secondaryAction={
                                    file.error ? <Ban color='red' /> : file.progress === 100 ? <CircleCheckBig color='green' /> : <CircularProgress variant="determinate" value={file.progress} />
                                }
                            >
                                <ListItemAvatar color={file.error ? "#96031A" : "black"}>
                                    <Avatar color={file.error ? "#96031A" : "black"} sx={{backgroundColor: file.error ? "red" :  file.progress === 100 ? "green" : "black"}}>
                                        <FileText />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={file.filename}
                                // secondary={secondary ? 'Secondary text' : null}
                                />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </Modal>
            <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                fullWidth
            >
                {label}
                <VisuallyHiddenInput
                    type="file"
                    multiple
                    id="inputFileHidden"
                    onChange={(event) => uploadFile(event.target.files)}
                />
            </Button>
        </>
    );
}
